export interface SidebarTab {
  id: string;
  current: boolean;
  hidden?: boolean;
}

export interface UiState {
  sidebar: {
    activeTabIndex: number | null;
    isClosing: boolean;
    isCollapsed: boolean; // Add this property
    tabs: {
      id: string;
      current: boolean;
    }[];
  },
  reportSidebar: {
    activeTabIndex: number | null;
    tabs: SidebarTab[];
    isClosing: boolean;
  };
  aside: {
    isOpen: boolean;
  };
  theme: {
    isDarkMode: boolean;
  };
  banner: {
    isSubscriptionVisible: boolean;
  };
}

export const initialUiState: UiState = {
  sidebar: {
    activeTabIndex: null,
    isClosing: false,
    isCollapsed: false, // Default to not collapsed
    tabs: [
      // Your existing tabs
    ]
  },
  reportSidebar: {
    activeTabIndex: 0,
    isClosing: false,
    tabs: [
      { id: 'tags', current: true },
      { id: 'assistant', current: false },
      { id: 'edit', current: false, hidden: true },
      { id: 'vault', current: false },
      { id: 'emails', current: false, hidden: true },
      { id: 'crm', current: false }
    ]
  },
  aside: {
    isOpen: true
  },
  theme: {
    isDarkMode: false
  },
  banner: {
    isSubscriptionVisible: true
  }
};
